import { render, staticRenderFns } from "./Charge.vue?vue&type=template&id=522d4a2c&scoped=true"
import script from "./Charge.vue?vue&type=script&lang=js"
export * from "./Charge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d4a2c",
  null
  
)

export default component.exports